import { Info } from "lucide-react";

const ReferralProgress = () => {
    return (
        <div className="card mb-4">
            <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="text-white fs-5 m-0">Referral Progress</h3>
                    <Info size={18} className="text-secondary" />
                </div>

                <div className="row g-3">
                    <div className="col-6">
                        <div
                            className="card h-100"
                            style={{
                                backgroundColor: "rgba(18, 18, 30, 0.8)",
                                borderRadius: "12px",
                            }}
                        >
                            <div className="card-body p-3 text-center">
                                <div
                                    className="position-relative mb-3"
                                    style={{ height: "120px" }}
                                >
                                    <div className="position-absolute top-50 start-50 translate-middle">
                                        <svg
                                            width="120"
                                            height="120"
                                            viewBox="0 0 120 120"
                                        >
                                            <circle
                                                cx="60"
                                                cy="60"
                                                r="54"
                                                fill="none"
                                                stroke="#2A2A3C"
                                                strokeWidth="12"
                                            />
                                            <circle
                                                cx="60"
                                                cy="60"
                                                r="54"
                                                fill="none"
                                                stroke="#4ECCA3"
                                                strokeWidth="12"
                                                strokeDasharray="339.3"
                                                strokeDashoffset="84.8"
                                                transform="rotate(-90 60 60)"
                                            />
                                        </svg>
                                        <div className="position-absolute top-50 start-50 translate-middle text-white fs-3 fw-bold">
                                            75%
                                        </div>
                                    </div>
                                </div>
                                <p className="text-white small mb-0">
                                    You're 75% closer to earning 5,000 MAC
                                    tokens!
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="row g-3 h-100">
                            <div className="col-12">
                                <ReferralStat
                                    value="12"
                                    label="Total Referrals"
                                />
                            </div>
                            <div className="col-12">
                                <ReferralStat
                                    value="8"
                                    label="Active Investors"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ReferralStat = ({ value, label }) => {
    return (
        <div
            className="card h-100"
            style={{
                backgroundColor: "rgba(18, 18, 30, 0.8)",
                borderRadius: "12px",
            }}
        >
            <div className="card-body p-3 text-center">
                <h4 className="text-white fs-2 fw-bold mb-1">{value}</h4>
                <p className="text-secondary small mb-0">{label}</p>
            </div>
        </div>
    );
};

export default ReferralProgress;
